import React from 'react';

const SpinnerWrapper = ({ children }) => (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '80vh', // تقریباً ارتفاع کل صفحه بدون هدر و فوتر
    }}>
      {children}
    </div>
  );


export default SpinnerWrapper;